<template>
  <div
    class="dark:bg-ontick-steel-500 bg-ontick-steel-300 grid w-full"
    :class="
      nameColSpan === 2
        ? `grid-cols-${activeHeadersLength + 1}`
        : `grid-cols-${activeHeadersLength}`
    "
  >
    <template v-for="header in headers">
      <button
        :key="header.key"
        v-if="!header.optional || (header.optional && header.active)"
        class="w-hull h-full space-x-1 py-2 px-4 text-left text-sm font-bold"
        :class="`col-span-${header.key === 'strategy_name' ? nameColSpan : 1}`"
        @click="sort(header.key)"
      >
        <span v-if="header.key === sortKey">
          {{ sortIcon }}
        </span>
        <span v-if="header.visible">
          {{ header.label }}
        </span>
      </button>
    </template>
  </div>
</template>

<script>
import event_bus from "../../../../../shared/utils/event_bus";
export default {
  props: {
    headers: {
      type: Array,
    },
    nameColSpan: {
      type: Number,
    },
  },

  data() {
    return {
      sortDirection: "",
      sortKey: "",
    };
  },

  computed: {
    sortIcon() {
      const directions = {
        asc: "▲",
        desc: "▼",
      };
      return directions[this.sortDirection] || "";
    },
    activeHeadersLength() {
      return this.headers.filter(
        (item) => !item.optional || (item.optional && item.active)
      ).length;
    },
  },

  methods: {
    sort(key) {
      if (key) {
        if (this.sortKey === key) {
          this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        } else {
          this.sortDirection = "asc";
        }
        this.sortKey = key;
      }
      event_bus.$emit("SET_INVESTMENT_LIST_FILTER", {
        sortDirection: this.sortDirection,
        sortKey: this.sortKey,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
